export default __webpack_public_path__ + "static/media/migration.8b3ab9a9.jpg";